module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('md-card', {
    staticClass: "light-frame",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("With MasterCard, VISA, AMEX")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("\n             You need to have a payment card like MasterCard, VISA ou AMEX."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n             You will receive your appeal within the next 48 hours.\n           ")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    staticStyle: {
      "max-width": "240px"
    },
    attrs: {
      "src": "/static/credit-card.svg"
    }
  })])], 1), _vm._v(" "), _c('md-card-media', {
    staticStyle: {
      "padding": "16px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClick('stripe')
      }
    }
  }, [_vm._v("Choose")])], 1)], 1), _vm._v(" "), _c('md-card', {
    staticClass: "light-frame",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Ask a friend to pay for you")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("\n            You know someone whocan pay for you witha payment card like MasterCard, VISA ou AMEX."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n            You will receive your appeal within the next 48 hours.\n           ")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    staticStyle: {
      "max-width": "240px"
    },
    attrs: {
      "src": "/static/credit-card2.svg"
    }
  })])], 1), _vm._v(" "), _c('md-card-media', {
    staticStyle: {
      "padding": "16px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClick('stripe-friend')
      }
    }
  }, [_vm._v("Choose")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "16px"
    }
  }, [_c('h2', [_vm._v("Choose your means of payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "padding-bottom": "16px"
    }
  }, [_vm._v("\n         You need to pay before making your appeal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc32fe12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/CheckoutPayment.vue
// module id = 747
// module chunks = 3